// imports section Start
import React, { useState, useEffect, useRef, createContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  useMediaQuery,
  Grid,
  IconButton,
  Tabs,
  Tab,
  Dialog,
  DialogContent,
  CircularProgress,
  Alert,
  Drawer,
  Pagination,
  tabsClasses,
  Button,
} from "@mui/material";

import { useTheme } from "@mui/material/styles";
import { useStyles } from "../../../assets/styles/Theme";

import {
  externalgetApi,
  externalpostApi,
} from "../../../services/external/externalApis";
import { COMMON_API_02 } from "../../../api/ApiModel";
import {
  addCashierItemToCart,
  clearCashierCart,
} from "../../../store/ReduxCashierCartReducer";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../../utils/sys/Constants";
import SnackbarMessage from "../../../components/common/SnackbarMessage";
import { ADD_TO_CART } from "../../../utils/sys/Messages";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { resetVouchers } from "../../../store/ReduxVoucherSlice";
import { clearSlips } from "../../../store/ReduxSlipSlice";
import { clearCheque } from "../../../store/ReduxChequeSlice";
import { resetCards } from "../../../store/ReduxCardSlice";
import dayjs from "dayjs";
import {
  clearLoyaltyData,
  setRedeemAmount,
} from "../../../store/ReduxLoyaltySlice";
import { resetCreditNote } from "../../../store/ReduxCreditNoteSlice";
import CashierCategoryMobile from "../../../components/mobile/cashier/cashier/CashierCategoryMobile";
import CashierHeaderMobile from "../../../components/mobile/cashier/cashier/CashierHeaderMobile";
import CashierFooterMobile from "../../../components/mobile/cashier/cashier/CashierFooterMobile";

// Create a context
export const CashierContext = createContext();

// imports section End

const CashierMobile = () => {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const tabsRef = useRef(null);
  const dispatch = useDispatch();
  const [value, setValue] = useState("All");
  const [mainDrawerOpen, setMainDrawerOpen] = useState(false);
  const [orderData, setOrderData] = useState(null);
  const [categoryDialogOpen, setCategoryDialogOpen] = useState(false);
  const [allItems, setAllItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [error, setError] = useState(null);
  const [categories, setCategories] = useState([]);
  const [dynamicCategories, setDynamicCategories] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [data, setData] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const [selectedWaiterTables, setSelectedWaiterTables] = useState([]);
  const [selectedWaiters, setSelectedWaiters] = useState([]);
  const [selectedAddons, setSelectedAddons] = useState([]);
  const [officerName, setOfficerName] = useState("");
  const [advanceAmount, setAdvanceAmount] = useState(0);
  const [cashTendered, setCashTendered] = useState(0);
  const [shippingCharge, setShippingCharge] = useState(0);
  const [adjustment, setAdjustment] = useState(0);
  const [grossAmount, setGrossAmount] = useState(0);
  const [rawDiscountValue, setRawDiscountValue] = useState("");
  const [discountType, setDiscountType] = useState("rate"); // Default to "rate"
  const [discountValue, setDiscountValue] = useState(""); // To store the entered discount value
  const [discountedTotal, setDiscountedTotal] = useState("0");
  const [deliveryDate, setDeliveryDate] = React.useState(dayjs());
  const [deliveryTime, setDeliveryTime] = React.useState(dayjs());
  const [contactPerson, setContactPerson] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [deliveryAddress, setDeliveryAddress] = useState("");
  const [table1Data, setTable1Data] = useState({});
  const [table2Data, setTable2Data] = useState({});
  const [table3Data, setTable3Data] = useState([]);
  const [orderDetails, setOrderDetails] = useState({ items: [] });
  const [orderBillDetails, setOrderBillDetails] = useState({ items: [] });
  const { state } = useLocation();
  const navigate = useNavigate();
  const cardList = useSelector((state) => state.cards.cardList);
  const chequeList = useSelector((state) => state.cheques.chequeList);
  const slipList = useSelector((state) => state.slips.slipList);
  const voucherList = useSelector((state) => state.vouchers.voucherList);
  const [responseValues, setResponseValues] = useState({
    advance: 0,
    afterCharge: 0,
    balance: 0,
    bank: 0,
    cash: 0,
    charge: 0,
    discount: 0,
    gift: 0,
    gross: 0,
    loyalty: 0,
    nettGross: 0,
    refundAmt: 0,
    shipping: 0,
    tax: 0,
    totNett: 0,
    totPaid: 0,
  });
  const [formData, setFormData] = useState({
    cash: { amount: "", clientname: "", refno: "" },
    card:
      cardList.length > 0
        ? cardList[0] // Use the first saved card
        : {
            cardname: "",
            cardaccountNumber: "",
            cardamount: 0,
            cardbank: "",
            cardbranch: "",
          },
    deposit: {
      slip:
        slipList.length > 0
          ? slipList[0]
          : {
              slipname: "",
              slipremark: "",
              slipamount: 0,
              slipbank: "",
              slipbranch: "",
            },
      cheque:
        chequeList.length > 0
          ? chequeList[0]
          : {
              chequename: "",
              chequeremark: "",
              chequeamount: 0,
              chequebank: "",
              chequebranch: "",
            },
    },
    redeem: {
      loyalty: { loyaltyamount: "", clientname: "" },
      voucher:
        voucherList.length > 0
          ? voucherList[0]
          : {
              voucherrefcode: "",
              vouchercode: "",
              voucherno: "",
              voucherbarcode: "",
              voucheramount: 0,
            },
    },
  });
  const [selectedTab, setSelectedTab] = useState(0);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  // State to store the calculated totals
  const [cardTotalAmount, setCardTotalAmount] = useState(0);
  const [slipTotalAmount, setSlipTotalAmount] = useState(0);
  const [chequeTotalAmount, setChequeTotalAmount] = useState(0);
  const [voucherTotalAmount, setVoucherTotalAmount] = useState(0);
  const [addonsData, setAddonsData] = useState([]); // Store fetched addons
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20; // Number of items per page

  useEffect(() => {
    // if (isLoggedIn && COMPCODE && LOCCODE && RESTCODE) {
    fetchData();
    fetchCategories();
    // }
  }, []);

  // Hooks end

  // Get user parameters from Redux store
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERREFCODE } =
    SYS_USER.USER_PARAM || {};

  // Handlers start
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  // Check if user is logged in
  const isLoggedIn = !!USERREFCODE;
  // Calculate totals dynamically whenever the lists change
  useEffect(() => {
    const calcCardTotal = cardList.reduce((total, card) => {
      const amount = parseFloat(card.cardamount) || 0;
      return total + amount;
    }, 0);
    setCardTotalAmount(calcCardTotal);

    const calcSlipTotal = slipList.reduce((total, slip) => {
      const amount = parseFloat(slip.slipamount) || 0;
      return total + amount;
    }, 0);
    setSlipTotalAmount(calcSlipTotal);

    const calcChequeTotal = chequeList.reduce((total, cheque) => {
      const amount = parseFloat(cheque.chequeamount) || 0;
      return total + amount;
    }, 0);
    setChequeTotalAmount(calcChequeTotal);
  }, [cardList, slipList, chequeList]); // Recalculate whenever these lists change

  // Calculate totals dynamically whenever the lists change
  useEffect(() => {
    const calcVoucherTotal = voucherList.reduce((total, voucher) => {
      const amount = parseFloat(voucher.voucheramount) || 0;
      return total + amount;
    }, 0);
    setVoucherTotalAmount(calcVoucherTotal);
  }, [voucherList]); // Recalculate whenever these lists change

  // Total amount across all categories
  const totalAmountBank = cardTotalAmount + slipTotalAmount + chequeTotalAmount;
  const totalAmountRedeem = voucherTotalAmount;

  // Handler for cash tendered input
  const handleCashTenderedChange = (e) => {
    handleNumericInput(e.target.value, setCashTendered);
  };

  const handleContinueToPayment = (order) => {
    setOrderData(order);
    setMainDrawerOpen(true);
  };
  // Function to handle numeric inputs (advance and cash tendered)
  const handleNumericInput = (value, setState) => {
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setState(value);
    }
  };

  useEffect(() => {
    // Clear cart on page load
    // setOrderDetails({ items: [] });
    // setOrderBillDetails({ items: [] });
    setFormData("");
    dispatch(setRedeemAmount(""));
    dispatch(clearCashierCart());
    dispatch(resetVouchers());
    dispatch(clearSlips());
    dispatch(clearCheque());
    dispatch(resetCards());
    dispatch(clearLoyaltyData());
    dispatch(resetCreditNote());
  }, [dispatch]);

  const handleAddToCart = (item) => {
    if (isLoggedIn) {
      dispatch(addCashierItemToCart(item));
    } else {
      alert("Please log in to add items to the cart.");

      setSnackbarMessage(ADD_TO_CART);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    }
  };
  const handleNavigate = () => {
    navigate("/Placedorder"); // Replace '/placedorders' with your exact route path
  };

  const handleSearch = (query) => {
    setSearchQuery(query);
    // Filter items based on the search query
    const filtered = allItems.filter(
      (item) =>
        item.MENUNAME.toLowerCase().includes(query.toLowerCase()) ||
        item.MENUREFCODE.toLowerCase().includes(query.toLowerCase())
    );
    // Sort items alphabetically by MENUNAME
    const sortedFilteredItems = filtered.sort((a, b) =>
      a.MENUNAME.localeCompare(b.MENUNAME)
    );
    setFilteredItems(sortedFilteredItems);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    filterItems(newValue);

    // Scroll to the selected tab
    const tabElement = tabsRef.current?.querySelector(
      `button[value="${newValue}"]`
    );
    tabElement?.scrollIntoView({ behavior: "smooth", inline: "center" });
  };

  const filterItems = (categoryCode) => {
    if (categoryCode === "All") {
      setFilteredItems(allItems);
    } else {
      setFilteredItems(
        allItems.filter((item) => item.MENUCATCODE === categoryCode)
      );
    }
  };
  const handleToggleDrawer = () => {
    setMainDrawerOpen(!mainDrawerOpen);
  };
  const handleCategoryDialogOpen = () => setCategoryDialogOpen(true);
  const handleCategoryDialogClose = () => setCategoryDialogOpen(false);

  const handleSelectCategory = (category) => {
    setValue(category.MENUCATCODE);
    filterItems(category.MENUCATCODE);
    setCategoryDialogOpen(false);
  };

  const handleViewOrder = (order) => setSelectedOrder(order);

  const sortedCategories = categories
    .filter((category) => category.MENUCATCODE !== "All")
    .sort((a, b) => a.MENUCATNAME.localeCompare(b.MENUCATNAME));

  const uniqueCategories = [
    { MENUCATCODE: "All", MENUCATNAME: "All" },
    ...dynamicCategories,
    ...sortedCategories,
  ].reduce((acc, category) => {
    if (!acc.some((cat) => cat.MENUCATCODE === category.MENUCATCODE)) {
      acc.push(category);
    }
    return acc;
  }, []);

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const calculateItemTotal = (item) => {
    // console.log("Item received for calculation:", item); // Debug log
    const rate = parseFloat(item.ITEMRATE || item.RATE || 0); // Check both ITEMRATE and RATE
    const quantity = parseFloat(item.quantity || item.QTY || 1);
    // console.log(`Rate: ${rate}, Quantity: ${quantity}`); // Debug log
    return rate * quantity;
  };

  const handleDiscountValueChange = (event) => {
    const value = parseFloat(event.target.value) || 0;

    if (discountType === "amount") {
      if (value > grossAmount) {
        setError(`Discount amount cannot exceed ${grossAmount}`);
        setRawDiscountValue(grossAmount); // Limit to grossAmount
        setDiscountValue((grossAmount / grossAmount) * 100); // Set to 100%
      } else {
        setError("");
        setRawDiscountValue(value); // Store raw integer value
        setDiscountValue((value / grossAmount) * 100); // Convert to percentage
      }
    } else if (discountType === "rate") {
      if (value > 100) {
        setError("Discount rate cannot exceed 100%");
        setDiscountValue(100); // Limit to 100%
      } else {
        setError("");
        setDiscountValue(value); // Use percentage directly
      }
    }
  };

  // Handlers end

  // API calls start
  const fetchData = async () => {
    try {
      const today = new Date();
      const formattedToday = `${today.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")} 23:59:59`;
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        TODAY: formattedToday,
        STS: CON_STATUS_ACTIVE,
      };
      const response = await externalgetApi(COMMON_API_02, "GET", params);
      setAllItems(response);
      setFilteredItems(response);
    } catch (error) {
      setError(error);
    } finally {
      setData(true);
    }
  };

  const fetchCategories = async () => {
    try {
      const today = new Date();
      const formattedToday = `${today.getFullYear()}-${String(
        today.getMonth() + 1
      ).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")} 23:59:59`;
      const params = {
        COMPCODE,
        LOCCODE,
        RESTCODE,
        TODAY: formattedToday,
        MENUTYPECODE: CON_MENU_TYPE_CODE,
        STS: CON_STATUS_ACTIVE,
      };
      const categoryResponse = await externalgetApi(
        COMMON_API_02,
        "GET",
        params
      );

      setCategories(categoryResponse);
    } catch (error) {
      setError(error);
    }
  };
  // API calls end

  return (
    <>
      <Box sx={styles.m_root}>
        <CashierHeaderMobile />

        {/* <Box>
          <CashierContentMobile />
        </Box> */}

        <Grid container>
          <CashierContext.Provider
            value={{
              selectedOrderType,
              setSelectedOrderType,
              selectedWaiterTables,
              setSelectedWaiterTables,
              selectedWaiters,
              setSelectedWaiters,
              cashTendered,
              setCashTendered,
              advanceAmount,
              setAdvanceAmount,
              handleCashTenderedChange,
              handleNumericInput,
              shippingCharge,
              setShippingCharge,
              adjustment,
              setAdjustment,
              grossAmount,
              setGrossAmount,
              discountType,
              setDiscountType,
              discountValue,
              setDiscountValue,
              discountedTotal,
              setDiscountedTotal,
              rawDiscountValue,
              setRawDiscountValue,
              table1Data,
              setTable1Data,
              table2Data,
              setTable2Data,
              table3Data,
              setTable3Data,
              handleDiscountValueChange,
              calculateItemTotal,
              deliveryDate,
              setDeliveryDate,
              deliveryTime,
              setDeliveryTime,
              contactPerson,
              setContactPerson,
              contactNumber,
              setContactNumber,
              deliveryAddress,
              setDeliveryAddress,
              responseValues,
              setResponseValues,
              formData,
              setFormData,
              totalAmountBank,
              cardTotalAmount,
              slipTotalAmount,
              chequeTotalAmount,
              totalAmountRedeem,
              voucherTotalAmount,
              orderDetails,
              setOrderDetails,
              orderBillDetails,
              setOrderBillDetails,
              officerName,
              setOfficerName,
              selectedAddons,
              setSelectedAddons,
              addonsData,
              setAddonsData,
            }}
          >
            <CashierFooterMobile
              selectedOrder={selectedOrder}
              handleContinueToPayment={handleContinueToPayment}
              orderData={orderData}
            />
          </CashierContext.Provider>
        </Grid>

        <Dialog
          open={categoryDialogOpen}
          onClose={handleCategoryDialogClose}
          aria-labelledby="category-dialog-title"
        >
          {/* <DialogContent> */}
          <CashierCategoryMobile
            categories={categories}
            onSelectCategory={handleSelectCategory}
            onClose={handleCategoryDialogClose}
          />
          {/* </DialogContent> */}
        </Dialog>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity} // Dynamic severity (success or error)
      />
    </>
  );
};

export default CashierMobile;
